export default __webpack_public_path__ + "static/media/Colgate_logo.418042a2.svg";